import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import usePages from '../../context/PageContext';
import masterDataService from '../../service/masterData.service';
import useMenus from '../../context/MenuContext';
import useParam from '../../context/ParamContext';
import useUsers from '../../context/UsersContext';

export const ProjectTypeHomePage = () => {
  const { setPages } = usePages();
  const { menus, getSubMenuNamesByUrls } = useMenus();
  const { params, getParam } = useParam();
  const { user, getUser } = useUsers();
  const navigate = useNavigate();
  const [types, setTypes] = useState([]);

  useEffect(() => {
    getTypes();
    if (!Object.keys(user).length) getUser();
    getParam();
  }, []);

  const getTypes = () => {
    masterDataService.homePageProjectTypeToForm().then((data) => {
      setTypes(data);
    });
  };

  const submenuNames = useMemo(() => {
    return getSubMenuNamesByUrls(['taskkanban']);
  }, [menus]);

  const handleNavigate = (projectTypeId) => {
    const roleIds = params.PROJECT_TYPE_HOME_PAGE_ADMIN ? JSON.parse(params.PROJECT_TYPE_HOME_PAGE_ADMIN) : [];

    if (roleIds.includes(user.roleId)) {
      navigate(`/app/taskkanban/Project/${projectTypeId}`);
    } else {
      navigate(`/app/taskkanban/taskList/${projectTypeId}`);
    }
    setPages({ subMenuName: submenuNames[0] });
  };

  return (
    <div className="bg-[#E9F5FE] px-6 pt-5" style={{ minHeight: 'calc(100vh - 65px)' }}>
      <div className="flex flex-wrap gap-5 justify-center">
        {types?.map((type) => (
          <div
            key={type.id}
            className="h-[150px] w-[250px] bg-[#bbf7d04d] text-[#16a34a] cursor-pointer flex flex-col items-center justify-center px-2 text-center hover:bg-[#bbf7d0] transition  duration-300 ease-in-out hover:-translate-y-1 hover:scale-110"
            onClick={() => handleNavigate(type.id)}
          >
            <div className="text-2xl mb-2">{type.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
